<template>
  <div v-loading="isLoading">
    <div>
      <rest-list
        :filterable="true"
        :payload="consentPreferencesChannelEndpoint"
        ref="consentPrefList"
        :apply-sorting-to-url="false"
        :apply-filters-to-url="false"
        @dataLoaded="recalculateChannelColumnWidth"
      >
        <rest-list-column
          prop="name"
          :title="$t('Profiles_Channels_Field_Name')"
          :fixed="true"
          :width="200"
        />

        <rest-list-column
          prop="display_name"
          :title="$t('Profiles_Channels_Field_DisplayName')"
          :width="200"
        />

        <rest-list-column-enum
          prop="type"
          :title="$t('Profiles_Channels_Field_ConsentType')"
          :enum="consentPreferenceType"
          :width="200"
        />

        <rest-list-column
          prop="subscription"
          :title="$t('Profiles_Channels_Field_SubscriptionStatus')"
          :sortable="false"
          :min-width="channelsColumnWidth"
          :filterable="false"
        >
          <template slot-scope="{ row }">
            <subscription-preference-channels
              :profile-id="profileId"
              :with-channels="withChannels"
              :preference="row"
              :channel-names="channels"
              @reload-preferences="reloadPreferences"
            />
          </template>
        </rest-list-column>

        <rest-list-column-date
          prop="update_time"
          :title="$t('Profiles_Channels_Field_LastChanged')"
          :width="200"
          fixed="right"
          :filterable="false"
        />
      </rest-list>
    </div>
  </div>
</template>

<script>
import { projectEndpoint } from '@/core/helpers'
import RestApi from '@/core/services/RestApi'
import RestList from '@/common/components/rest/RestList'
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestListColumnDate from '@/common/components/rest/RestListColumnDate'
import RestListColumnEnum from '@/common/components/rest/RestListColumnEnum'
import { SubscriptionPreferenceChannelLabels } from '@/modules/settings/enum/SubscriptionPreferenceChannelEnum'
import { subscriptionStatusKeys } from '@/modules/profiles/enum/SubscriptionStatusEnum'
import { ConsentChannels } from '@/modules/profiles/enum/ConsentChannelEnum'
import { consentPreferenceType } from '@/modules/consent-manager/enum/ConsentPreferenceEnums'
import SubscriptionPreferenceChannels from '@/modules/profiles/components/SubscriptionPreferenceChannels'

export default {
  name: 'ConsentPreferences',

  components: {
    RestList,
    RestListColumn,
    RestListColumnDate,
    RestListColumnEnum,
    SubscriptionPreferenceChannels
  },

  props: {
    profileId: {
      required: true
    },

    withChannels: {
      type: Boolean,
      default: true
    }
  },

  mounted() {
    this.isLoading = true
    RestApi(
      projectEndpoint({
        method: 'get',
        url: `consent-channels`,
        params: {
          sort: 'name'
        }
      })
    )
      .then(({ data }) => {
        this.channels = [
          {
            key: ConsentChannels.PUSH,
            name: this.$t('Profiles_Channels_Channel_Push')
          },
          {
            key: ConsentChannels.EMAIL,
            name: this.$t('Profiles_Channels_Channel_Email')
          },
          {
            key: ConsentChannels.SMS,
            name: this.$t('Profiles_Channels_Channel_SMS')
          },
          ...data.map(c => {
            delete c.id
            return c
          })
        ]
        this.isLoading = false
      })
      .catch(error => {
        this.$message({
          message: error.message,
          type: 'error'
        })
      })
  },

  computed: {
    consentPreferencesChannelEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `profiles/${this.$route.query.profile_id}/consent-preferences`,
        params: {
          sort: 'name',
          'with-channels': this.withChannels ? 'true' : 'false',
          fields: 'type,name,display_name,channels,update_time',
          expand: 'channels'
        }
      })
    }
  },

  data: function() {
    return {
      subscriptionStatusKeys,
      SubscriptionPreferenceChannelLabels,
      consentPreferenceType,
      isLoading: false,
      channels: [],
      auditLogSubscriptionPreferenceRow: {},
      channelsColumnWidth: 0
    }
  },

  methods: {
    handleGlobalChannelSubscriptionChange(preference) {
      if (!preference) return

      if (
        ['email', 'sms', 'whatsapp'].includes(
          preference.replace('_subscription', '').toLowerCase()
        )
      ) {
        this.$refs.consentPrefList.refresh()
      }
    },

    recalculateChannelColumnWidth(data) {
      this.$nextTick(() => {
        const channelsColumn = this.$refs.consentPrefList.$el.querySelector(
          '.consent-preference-channels'
        )

        if (channelsColumn && this.channelsColumnWidth === 0) {
          let resultSize = 0
          channelsColumn.childNodes.forEach(
            el => (resultSize += el.offsetWidth)
          )
          this.channelsColumnWidth =
            resultSize + (channelsColumn.childElementCount - 1) * 21
        }
      })
    },

    reloadPreferences() {
      this.$refs.consentPrefList.refresh()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/profiles/components/ConsentPreferences.vue